import { graphql, useStaticQuery } from 'gatsby';


type PolicyFrontMatterProps = {
  title: string;
  date: Date;
  page: string;
  published: boolean;
  category: string;
  tags: string[];
  authors: string[];
  description: string;
};

export interface PolicyProps {
  id: string;
  body: string;
  excerpt: string;
  internal: {
    contentFilePath: string;
  }
  frontmatter: PolicyFrontMatterProps;
};

const cancellationPolicyQuery = () => {
  const data = useStaticQuery(graphql`
    query CancellationPolicyQuery {
        policy: mdx(frontmatter: {page: {eq: "cancellation"}}) {
            id
            body
            excerpt
            tableOfContents
            frontmatter {
                title
                date(formatString: "MMMM DD, YYYY")
                page
                authors
                description
                category
                tags
                published
            }
            internal {
                contentFilePath
            }
        }
    }
`);

  const policy: PolicyProps = data.policy;
  return { policy };
};



export { cancellationPolicyQuery };